// extracted by mini-css-extract-plugin
export default {"googleButton":"GoogleLogin_googleButton__0F1D4"};